import PropTypes from "prop-types";
// @mui
import { Skeleton, Box, Card, Typography } from "@mui/material";
import { Stack } from "@mui/system";

// ----------------------------------------------------------------------

SkeletonKycBusinessInfo.propTypes = {
  sx: PropTypes.object,
};

export default function SkeletonKycBusinessInfo({ sx, ...other }) {
  return (
    <Card sx={{ p: 3, mt: 4 }}>
      <Stack>
        <Skeleton variant="text">
          <Typography variant="h6">Business Information</Typography>
        </Skeleton>

        <Box
          rowGap={3}
          mt={4}
          mb={6}
          columnGap={2}
          display="grid"
          gridTemplateColumns={{
            xs: "repeat(1, 1fr)",
            sm: "repeat(2, 1fr)",
          }}
        >
          <Skeleton
            variant="rectangular"
            sx={{ height: 56, borderRadius: 1 }}
          />{" "}
          <Skeleton
            variant="rectangular"
            sx={{ height: 56, borderRadius: 1 }}
          />{" "}
          <Skeleton
            variant="rectangular"
            sx={{ height: 56, borderRadius: 1 }}
          />{" "}
          <Skeleton
            variant="rectangular"
            sx={{ height: 56, borderRadius: 1 }}
          />
          <Skeleton
            variant="rectangular"
            sx={{ height: 56, borderRadius: 1 }}
          />
          <Skeleton
            variant="rectangular"
            sx={{ height: 56, borderRadius: 1 }}
          />
        </Box>
      </Stack>

      <Stack>
        <Skeleton variant="text">
          <Typography variant="h6">Business Information</Typography>
        </Skeleton>

        <Box
          rowGap={3}
          mt={4}
          mb={6}
          columnGap={2}
          display="grid"
          gridTemplateColumns={{
            xs: "repeat(1, 1fr)",
            sm: "repeat(2, 1fr)",
          }}
          alignItems={"flex-start"}
        >
          <Skeleton
            variant="rectangular"
            sx={{ height: 56, borderRadius: 1 }}
          />{" "}
          <Skeleton
            variant="rectangular"
            sx={{ height: 56, borderRadius: 1 }}
          />{" "}
          <Skeleton
            variant="rectangular"
            sx={{ height: 56, borderRadius: 1 }}
          />{" "}
          <Skeleton
            variant="rectangular"
            sx={{ height: 56, borderRadius: 1 }}
          />{" "}
          <Skeleton
            variant="rectangular"
            sx={{ height: 56, borderRadius: 1 }}
          />
        </Box>
      </Stack>

      <Skeleton variant="rectangular" sx={{ height: 56, borderRadius: 1 }} />

      <Stack mt={3}>
        <Skeleton variant="text">
          <Typography variant="h6">Business Information</Typography>
        </Skeleton>

        <Box
          rowGap={3}
          mt={4}
          mb={6}
          columnGap={2}
          display="grid"
          gridTemplateColumns={{
            xs: "repeat(1, 1fr)",
            sm: "repeat(2, 1fr)",
          }}
        >
          <Skeleton
            variant="rectangular"
            sx={{ height: 56, borderRadius: 1 }}
          />{" "}
          <Skeleton
            variant="rectangular"
            sx={{ height: 56, borderRadius: 1 }}
          />{" "}
          <Skeleton
            variant="rectangular"
            sx={{ height: 56, borderRadius: 1 }}
          />
        </Box>
      </Stack>
    </Card>
  );
}
